import React, { useState } from 'react';
import ListHeader from '../ListComponents/ListHeader';
import ExternallyCollapsibleHeader from './ExternallyCollapsibleHeader';
import classnames from 'classnames';

const CollapsibleList = ({
  contentTitle,
  collapsedState,
  toggleCollapse,
  datatestid,
  children,
  isFAQTitleBold,
  ...props
}) => {
  return (
    <>
      <ListHeader
        headerText={contentTitle}
        isFAQTitleBold={isFAQTitleBold}
        isListExpanded={collapsedState}
        hideCount={true}
        datatestid={'collapsibleContentHeader'}
        onClick={toggleCollapse}
        tabIndex={'0'}
        listType={props.listType}
        showMinusIcon={props.showMinusIcon}
      />
      {collapsedState && (
        <div
          data-testid={datatestid ? `${datatestid}-collapsibleSection` : null}
          {...props}
        >
          {children}
        </div>
      )}
    </>
  );
};

const ExternallyCollapsibleComponent = ({
  datatestid,
  contentTitle,
  collapsedState,
  toggleCollapse,
  isExpanded,
  children,
  ...props
}) => {
  return (
    <>
      <ExternallyCollapsibleHeader
        headerText={contentTitle}
        isExpanded={isExpanded}
        expandCallback={toggleCollapse}
        datatestid={datatestid}
      />
      {isExpanded && (
        <div
          data-testid={datatestid ? `${datatestid}-collapsibleSection` : null}
          {...props}
        >
          {children}
        </div>
      )}
    </>
  );
};

const CollapsibleComponent = function ({
  className,
  datatestid,
  contentTitle,
  children,
  expandCallback,
  isExpanded = true,
  externallyCollapsible,
  ...props
}) {
  const [collapsedState, setCollapsedState] = useState(isExpanded);
  const toggleCollapse = function () {
    if (expandCallback && typeof expandCallback !== 'undefined') {
      expandCallback(collapsedState);
    }
    setCollapsedState(!collapsedState);
  };
  return (
    <div className={classnames('collapsibleComponentContainer', className)}>
      {externallyCollapsible ? (
        <ExternallyCollapsibleComponent
          isExpanded={isExpanded}
          contentTitle={contentTitle}
          collapsedState={isExpanded}
          toggleCollapse={expandCallback}
          datatestid={datatestid}
          children={children}
          {...props}
        />
      ) : (
        <CollapsibleList
          contentTitle={contentTitle}
          collapsedState={collapsedState}
          toggleCollapse={toggleCollapse}
          datatestid={datatestid}
          children={children}
          {...props}
        />
      )}
    </div>
  );
};

export default CollapsibleComponent;
